// Firebase project database configuration
export const DB_CONFIG = {
   apiKey: "AIzaSyBwJaZUgORnVI7z_iqoWVgh_0h0hycai9M",
    authDomain: "inheritance-publications.firebaseapp.com",
    databaseURL: "https://inheritance-publications.firebaseio.com",
    projectId: "inheritance-publications",
    storageBucket: "inheritance-publications.appspot.com",
    messagingSenderId: "954566753787",
    appId: "1:954566753787:web:4d5977bedeae109dce1f5e",
    measurementId: "G-0711S2EL9G"
}